import * as React from "react";
const SvgCheckmark = (props) => /* @__PURE__ */ React.createElement("svg", { width: 25, height: 23, viewBox: "0 0 25 23", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3 14.5L10 20L22 3", stroke: "currentColor", strokeWidth: 3, strokeLinecap: "square" }));
export default SvgCheckmark;
